import Transitions from "Components/Transitions/Transitions";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useAuth } from "@clerk/clerk-react";
import { Skeleton } from "Components/ui/skeleton";
import UseInnerWidth from "hooks/UseInnerWidth";
import CurrencyFlag from "react-currency-flags";
import oneBar from "../../Assets/Images/oneBar.svg";
import threeBar from "../../Assets/Images/threeBars.svg";
import twoBar from "../../Assets/Images/twoBars.svg";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@radix-ui/react-tooltip";
import MultiSelect from "Components/MultiSelectDropdown/MultiSelect";
import { Separator } from "Components/ui/separator";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "Components/ui/table";
import { TriangleAlert } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { getCalendarData } from "../../Redux/Calendar/CalendarActions";

const Calendar = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const { Calendar, getCalendarLoading } = useSelector(
    (state) => state.CalendarReducer
  );

  function getDateOfWeekday(dayName) {
    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const today = new Date();
    const todayIndex = today.getDay(); // 0 (Sun) to 6 (Sat)
    const targetIndex = dayNames.findIndex(
      (d) => d.toLowerCase() === dayName.toLowerCase()
    );

    if (targetIndex === -1) throw new Error("Invalid day name");

    // Calculate difference (can be negative)
    const diff = targetIndex - todayIndex;

    // Get target date
    const targetDate = new Date(today);
    targetDate.setDate(today.getDate() + diff);

    // Format YYYY-MM-DD
    const yyyy = targetDate.getFullYear();
    const mm = String(targetDate.getMonth() + 1).padStart(2, "0");
    const dd = String(targetDate.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }

  const [selected, setSelected] = useState(0);
  const [filter, setFilter] = useState({
    date: getDateOfWeekday("Monday"),
  });
  const [selectedType, setSelectedType] = useState();
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedStatus, setSelectedStatus] = useState();
  const [startSelectedDate, setStartSelectedDate] = useState(null);
  const [endSelectedDate, setEndSelectedDate] = useState(null);

  const dispatch = useDispatch();
  const { getToken } = useAuth();
  const width = UseInnerWidth();

  useEffect(() => {
    console.log(filter);
    dispatch(getCalendarData(getToken, filter));
  }, [filter]);

  const [SelectedDay, setSelecteDay] = useState("Monday");

  const ImpactLevel = [
    { label: "Low", value: "Low" },
    { label: "Medium", value: "Medium" },
    { label: "High", value: "High" },
  ];

  const currencies = [
    { label: "USD", value: "USD" },
    { label: "GBP", value: "GBP" },
    { label: "JPY", value: "JPY" },
    { label: "NZD", value: "NZD" },
    { label: "SEK", value: "SEK" },
    { label: "AUD", value: "AUD" },
    { label: "CAD", value: "CAD" },
    { label: "CHF", value: "CHF" },
    { label: "EUR", value: "EUR" },
  ];
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

  return (
    <>
      <div
        className={`flex mt-10 ${
          width < 500 ? "flex-col" : "flex-row justify-between items-center"
        }`}
      >
        <div className={`text-[30px] font-G_SemiBold ${width < 500 && "mb-6"}`}>
          Upcoming Week Economic Calendar
        </div>
      </div>
      <div
        className={`flex ${
          width < 768 ? "flex-col" : "flex-row justify-between items-center"
        } gap-4 my-4`}
      >
        <div
          className={`flex  
           ${
             width > 600
               ? "flex-row w-full justify-between  "
               : "flex-wrap w-full justify-start  items-start"
           }`}
        >
          <div className="w-full flex flex-row gap-1 w-fit">
            {days.map((day) => (
              <span
                key={day}
                onClick={() => {
                  const selectedDate = getDateOfWeekday(day);
                  setFilter({ ...filter, date: selectedDate });
                  setSelecteDay(day);
                }}
                className={`cursor-pointer px-2 py-0 h-[36px] w-[7rem] rounded-lg flex items-center justify-center ${
                  SelectedDay === day ? "bg-[#005EA247] text-white" : ""
                }`}
              >
                {day}
              </span>
            ))}
          </div>
          <div className="flex gap-4">
            <div className="w-full  sm:w-[14rem]  ">
              <MultiSelect
                maxCount={1}
                type="Currency"
                options={ImpactLevel}
                placeholder={"Impact Level"}
                value={filter.impact || []}
                onValueChange={(selectedValues) => {
                  const selectedString = selectedValues
                    .filter((val) => val !== true)
                    .join(",");
                  console.log("Selected String:", selectedString);

                  setFilter((prevFilter) => {
                    const updatedFilter = { ...prevFilter };

                    if (selectedValues.length === 0) {
                      delete updatedFilter.impact;
                    } else {
                      updatedFilter.impact = selectedString;
                    }

                    return updatedFilter;
                  });
                }}
              />
            </div>

            <div className="w-full  sm:w-[14rem]  ">
              <MultiSelect
                maxCount={1}
                options={currencies}
                placeholder={"Currency"}
                value={filter.currency || []}
                onValueChange={(selectedValues) => {
                  const selectedString = selectedValues
                    .filter((val) => val !== true)
                    .join(",");
                  console.log("Selected String:", selectedString);

                  setFilter((prevFilter) => {
                    const updatedFilter = { ...prevFilter };

                    if (selectedValues.length === 0) {
                      delete updatedFilter.currency;
                    } else {
                      updatedFilter.currency = selectedString;
                    }

                    return updatedFilter;
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-8 mb-8 bg-background-card rounded-xl">
        {!Calendar?.records || Object.keys(Calendar.records).length === 0 ? (
          <div className="text-base text-white-opacity h-[20rem] flex flex-col gap-0 items-center justify-center cursor-pointer ">
            <div className="font-G_SemiBold text-2xl">No data Available</div>
          </div>
        ) : width > 600 ? (
          <>
            <div className="rounded-2xl max-h-[60vh] px-4 overflow-auto relative hideScrollBar">
              <Table className="border-separate border-spacing-y-3 border-spacing-x-0  w-full  ">
                <TableHeader>
                  <TableRow>
                    <TableHead>Time</TableHead>
                    <TableHead>Currency</TableHead>
                    <TableHead>Event</TableHead>
                    <TableHead>Actual</TableHead>
                    <TableHead>Forecast</TableHead>
                    <TableHead>Previous</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {getCalendarLoading
                    ? Array.from({ length: 7 }).map((_, index) => (
                        <TableRow key={index} className="rounded-full">
                          <TableCell className="rounded-l-2xl py-4">
                            <Skeleton className="h-5 w-16" />
                          </TableCell>
                          <TableCell className="break-keep whitespace-nowrap">
                            <Skeleton className="h-5 w-32" />
                          </TableCell>
                          <TableCell>
                            <Skeleton className="h-5 w-24" />
                          </TableCell>
                          <TableCell className="">
                            <Skeleton className="h-5 w-16" />
                          </TableCell>
                          <TableCell>
                            <Skeleton className="h-5 w-24" />
                          </TableCell>
                          <TableCell className="rounded-r-2xl">
                            <Skeleton className="h-5 w-16" />
                          </TableCell>
                        </TableRow>
                      ))
                    : Calendar?.records?.map((item, index) => (
                        <TableRow
                          key={item.id || index}
                          className={`rounded-full
                ${item.forBreach === true ? "bg-[#ED1F2078] text-white " : ""}

                `}
                        >
                          <TableCell className="rounded-l-2xl py-4 font-G_SemiBold ml-20">
                            <div className="border border-borderWhite border-[#FFFFFF15] w-[5rem] py-1 rounded-md flex items-center justify-center">
                              {item.time}
                            </div>
                          </TableCell>
                          <TableCell className="break-keep whitespace-nowrap">
                            <div className="flex items-center gap-2">
                              <div className="w-10 h-10 rounded-full overflow-hidden">
                                <CurrencyFlag
                                  currency={item.currency}
                                  width={10}
                                  height={10}
                                  className="w-full h-full object-contain bg-center"
                                />
                              </div>

                              <span className="font-G_regular">
                                {item.currency}
                              </span>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="flex flex-row items-center gap-2 w-fit p-1 font-G_regular">
                              <img
                                src={`${
                                  item.impact === "Low"
                                    ? oneBar
                                    : item.impact === "Medium"
                                    ? twoBar
                                    : threeBar
                                }`}
                                alt="charts"
                                className="w-5 h-5"
                              />

                              {item.event}
                              {item.forBreach === true && (
                                <TooltipProvider>
                                  <Tooltip>
                                    <TooltipTrigger
                                      asChild
                                      className="font-G_regular"
                                    >
                                      <TriangleAlert className="text-[#ED1F20] cursor-pointer ml-2" />
                                    </TooltipTrigger>
                                    <TooltipContent className="bg-[#4B0C10] text-[#ED1F20] p-3 rounded-md max-w-[20rem] break-words whitespace-normal ml-[22rem]">
                                      <div>
                                        <p>
                                          Trading during this event is
                                          restricted. Violating this rule may
                                          result in penalties or suspension.
                                        </p>
                                      </div>
                                    </TooltipContent>
                                  </Tooltip>
                                </TooltipProvider>
                              )}
                            </div>
                          </TableCell>

                          <TableCell>
                            <div
                              className={`flex flex-row items-center gap-2 w-fit p-1 ${
                                item.actual === "" || item.actual == null
                                  ? "text-white"
                                  : parseFloat(
                                      item.actual.replace(/[^0-9.-]+/g, "")
                                    ) < 0
                                  ? "text-red"
                                  : "text-green"
                              }`}
                            >
                              {item.actual !== "" && item.actual != null
                                ? item.actual.replace("-", "")
                                : "-"}
                            </div>
                          </TableCell>
                          <TableCell>
                            <div
                              className={`flex flex-row items-center gap-2 w-fit p-1 ${
                                item.forecast === "" || item.forecast == null
                                  ? "opacity-50"
                                  : parseFloat(
                                      item.forecast.replace(/[^0-9.-]+/g, "")
                                    ) < 0
                                  ? "opacity-50"
                                  : "opacity-100"
                              }`}
                            >
                              {item.forecast !== "" && item.forecast != null
                                ? item.forecast.replace("-", "")
                                : "-"}
                            </div>
                          </TableCell>
                          <TableCell>
                            <div
                              className={`flex flex-row items-center gap-2 w-fit p-1 ${
                                item.previous === "" || item.previous == null
                                  ? "topacity-50"
                                  : parseFloat(
                                      item.previous.replace(/[^0-9.-]+/g, "")
                                    ) < 0
                                  ? "opacity-50"
                                  : "opacity-100"
                              }`}
                            >
                              {item.previous !== "" && item.previous != null
                                ? item.previous.replace("-", "")
                                : "-"}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </div>
          </>
        ) : !getCalendarLoading ? (
          <div className="p-4">
            <div className="flex flex-col gap-4">
              {Calendar?.records?.map((item, index) => (
                <div key={index}>
                  <Separator className="bg-white opacity-[0.3] my-4" />

                  <div className="flex flex-col gap-2 bg-primary-opacity rounded-lg p-4">
                    {/* Currency */}
                    <div className="flex flex-row items-center gap-2 justify-between">
                      <div className="text-lg font-B_Light opacity-[0.3]">
                        Currency
                      </div>
                      <div>
                        <span className="font-G_regular">{item.currency}</span>
                      </div>
                    </div>

                    {/* Actual */}
                    <div className="flex flex-row items-center gap-2 justify-between">
                      <div className="text-lg font-B_Light opacity-[0.3]">
                        Actual
                      </div>
                      <div
                        className={`font-B_Medium text-lg ${
                          item.actual === "" || item.actual == null
                            ? "text-white"
                            : parseFloat(
                                item.actual.replace(/[^0-9.-]+/g, "")
                              ) < 0
                            ? "text-red"
                            : "text-green"
                        }`}
                      >
                        {item.actual !== "" && item.actual != null
                          ? item.actual.replace("-", "")
                          : "-"}
                      </div>
                    </div>

                    {/* forecast */}
                    <div className="flex flex-row items-center gap-2 justify-between">
                      <div className="text-lg font-B_Light opacity-[0.3]">
                        forecast
                      </div>
                      <div
                        className={`font-B_Medium text-lg ${
                          item.forecast === "" || item.forecast == null
                            ? "opacity-100"
                            : parseFloat(
                                item.forecast.replace(/[^0-9.-]+/g, "")
                              ) < 0
                            ? "opacity-50"
                            : "opacity-100"
                        }`}
                      >
                        {item.forecast !== "" && item.forecast != null
                          ? item.forecast.replace("-", "")
                          : "-"}
                      </div>
                    </div>

                    {/* Previous */}
                    <div className="flex flex-row items-center gap-2 justify-between">
                      <div className="text-lg font-B_Light opacity-[0.3]">
                        Previous
                      </div>
                      <div className="font-B_Medium text-lg">
                        {item.previous !== "" && item.previous != null
                          ? item.previous.replace("-", "")
                          : "-"}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          Array.from({ length: 3 }).map((_, index) => (
            <TableRow
              key={index}
              className="bg-background-cardDark rounded-full"
            >
              <TableCell className="rounded-l-2xl py-4">
                <Skeleton className="h-5 w-16" />
              </TableCell>
              <TableCell className="break-keep whitespace-nowrap">
                <Skeleton className="h-5 w-32" />
              </TableCell>
              <TableCell>
                <Skeleton className="h-5 w-24" />
              </TableCell>
              <TableCell className="rounded-r-2xl">
                <Skeleton className="h-5 w-16" />
              </TableCell>
            </TableRow>
          ))
        )}
      </div>
    </>
  );
};

export default Calendar;
